import { Outlet } from 'react-router-dom';
import { UniverseTabs, type UniverseTab } from '../../components/templates/UniverseTabs';
import styles from '../../components/templates/UniverseLayout.module.css';

/* Analyses available under the Titles universe. Add tabs here as they ship
   (e.g. genres, franchises, adoption) — the shell and routing follow. */
const TITLES_TABS: UniverseTab[] = [
  { id: 'leaderboard', label: 'Leaderboard' },
  { id: 'genres', label: 'Genres' },
];

export function TitlesLayout() {
  return (
    <div className={styles.base}>
      <h1 className={styles.title}>Titles</h1>
      <UniverseTabs baseRoute="/titles" tabs={TITLES_TABS} />
      <Outlet />
    </div>
  );
}
